//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef } from "react";
import { withRouter, Link } from "react-router-dom";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import validateData from "../../functions/validateData";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import MainNav from "../../components/navigations/MainNav";
import Main from "../../components/main/Main";
import DisplayScore from "../../components/display/DisplayScore";
import Overview from "../../components/display/Overview";
import ReviewForm from "../../components/forms/ReviewForm";
import AnimateLayout from "../../components/layout/AnimateLayout";
import AlphaTable from "../../components/tables/AlphaTable";
import PriviewOverview from "../../components/display/PriviewOverview";
import Message from "../../components/alerts/Message";
import Title from "../../components/text/Title";
import Layout from "../../components/layout/Layout";
import Icon from "../../components/icons/Icon";
import FormioForm from "../../components/forms/FormioForm";

// DATA MODEL
import caseDataModel from "../../data_model/review_admin/case/case_data";
import ContentAccordion from "../../components/display/ContentAccordion";
import { injectIntl } from "react-intl";

function Case({ match, info, history, intl }) {
  const isInitialMount = useRef(false);
  const _id = 3589204823904809;
  const dispatch = useDispatch();

  const [counterData, setCounterData] = useState();
  const [cases, setCases] = useState();
  const [reviewCase, setReviewCase] = useState();
  const [reviewers, setReviewers] = useState();
  const [formDataWithContent, setFormDataWithContent] = useState();
  const [formData, setFormData] = useState();
  const [activeCase, setActiveCase] = useState(null);
  const [score, setScore] = useState();
  const [overview, setOverview] = useState();

  const reduxState = useSelector(state => state);
  const reviewer = useSelector(state => state.reviewer);
  const sizeOfTheScreen = useSelector(state => state.app.sizeOfTheScreen);

  const init = useCallback(() => {
    getMainData();
  }, []);

  // run once on page load
  useEffect(init, []);

  // on route change
  useEffect(() => {
    if (isInitialMount.current) {
      getMainData();
    } else {
      isInitialMount.current = true;
    }
  }, [match]);

  const handleTableLinkClick = link => {
    //get form data
    AJAX()
      .get(_id, link)
      .then(res => {
        setFormDataWithContent(null);
        formData.content = res.data.result.content;
        setFormDataWithContent(formData);

        setScore(res.data.result.score);

        // If on mobile size
        if (sizeOfTheScreen && sizeOfTheScreen === "mobile") {
          dispatch({ type: ACTIONS.SHOW_HELPER_NAV_ON_TOP });
        } else if (sizeOfTheScreen && sizeOfTheScreen === "desktop") {
          dispatch({ type: ACTIONS.SHOW_HELLPER_SIDE_NAV });
        }
        dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_PRESENT });
      });
  };

  // // set the counter with data from judge module
  // useEffect(() => {
  //   if (reduxState.reviewer && reduxState.reviewer.expiresAt) {
  //     setCounterData(reduxState.reviewer.expiresAt);
  //   }
  // }, [reduxState]);

  const getMainData = () => {
    AJAX()
      .getReviewCase(_id, reduxState, match.params.id)
      .then(res => {
        const isDataValid = validateData(
          "Reviewer > Case > AJAX().getReviewCase",
          res,
          caseDataModel
        );

        if (isDataValid) {
          setReviewCase(res.data);

          setActiveCase(res.data.case);
          setCases(res.data.case.nav.cases);
          const formData = res.data.case.form;

          formData.actions = {};
          setFormData(formData);
          setOverview(res.data.case.overview);

          dispatch({
            type: ACTIONS.SET_PAGE_IDS,
            payload: { stage: res.data.case.stage_id, collection: res.data.case.collection_id },
          });

          AJAX()
            .get(_id, res.data.case.assignments_url)
            .then(res => setReviewers(res.data));
        }
      });
  };

  const handleNavItemClick = () => {
    dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
    dispatch({ type: ACTIONS.HIDE_HELLPER_SIDE_NAV });
  };

  // ON UNMOUNT
  useEffect(() => {
    return () => {
      dispatch({ type: ACTIONS.HIDE_HELLPER_SIDE_NAV });
      dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_NOT_PRESENT });
    };
  }, []);

  return (
    <NewAppHOC>
      <MainAsideNav>
        {/* <AnimateLayout animate={cases}> */}
          <Link to="/ui/review_admin/dashboard">
            <Layout flex>
              <div>
                <Icon
                  iconId="categoriesFull"
                  addClass="c1 __n_bi"
                  style={{ marginRight: ".7rem" }}
                />
              </div>
              <Title tagName="h1" addClass="c16" removeWeight>
                {intl.formatMessage({ id: "reviewAdminDashboard" })}
              </Title>
            </Layout>
          </Link>
          {activeCase && (
            <div>
              <Link to={`/ui/review_admin/stage/${activeCase.stage_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="categoriesFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {activeCase.breadcrumbs.stage.title}
                  </Title>
                </Layout>
              </Link>
              <Link to={`/ui/review_admin/collection/${activeCase.collection_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="listFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {activeCase.breadcrumbs.collection.title}
                  </Title>
                </Layout>
              </Link>
            </div>
          )}
          {cases && (
            <MainNav
              clicked={handleNavItemClick}
              title={intl.formatMessage({ id: "allProjectsCollection" })}
              titleTag="h1"
              data={cases}
              linkTo="/ui/review_admin/case"
              activeItem={match.params.id}
            />
          )}
        {/* </AnimateLayout> */}
      </MainAsideNav>

      <Main counter={counterData}>
        {/* <AnimateLayout animate={reviewers}> */}
          {reviewers && (
            <div>
              {overview.additional_content && (
                <ContentAccordion
                  firstContent={overview.additional_content.collapsed_content}
                  secondContent={overview.additional_content.content}
                />
              )}
              <PriviewOverview data={overview}>
                <Overview overviewData={overview} readonly={true} />
              </PriviewOverview>
              {reviewers.data.length === 0 ? (
                <Message msg={intl.formatMessage({ id: "projectNotAssigned" })} />
              ) : (
                <AlphaTable
                  linkCallBack={handleTableLinkClick}
                  data={reviewers}
                  dontRenderAlerter
                />
              )}
            </div>
          )}
        {/* </AnimateLayout> */}
      </Main>
      <HelperAsideNav>
        {formDataWithContent && (
          <div>
            <DisplayScore style={{ marginBottom: "3rem" }} addClass="c10 bc1" score={score} />
            <FormioForm formData={formDataWithContent} blockFormSubmission />
            {/* <ReviewForm
              blockFormSubmission={true}
              disableForm={true}
              info={info}
              form={formDataWithContent}
            /> */}
          </div>
        )}
      </HelperAsideNav>
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(Case));
